<template>
  <v-dialog :value="!!type" max-width="600" persistent>
    <v-card>
      <v-card-title class="headline accent--text pb-4">{{ computedTitleDialog }}</v-card-title>
      <v-card-text outlined tile class="border-top py-4">
        <template v-if="!checkMsg">
          <v-text-field
            v-if="computedLabel"
            v-model="text"
            :label="computedLabel"
            :placeholder="computedPlaceholder"
            hide-details
            outlined
            dense
            rounded
          />

          <p v-else class="accent--text">{{ computedMessageDialog }}</p>
        </template>

        <template v-else>
          <p
            v-for="(item, i) in messages"
            :key="i"
            class="accent--text"
          >
            {{ item.text }}
          </p>

          <p v-if="!messages.length" class="accent--text">Сообщений нет</p>
        </template>

      </v-card-text>

      <v-card-actions class="px-6 pt-0">
        <v-spacer></v-spacer>
        <v-btn text color="lightGrey" @click="closeDialog">Отмена</v-btn>
        <v-btn
          v-if="!checkMsg"
          :loading="loading"
          color="lightGrey"
          :disabled="$v.$invalid && disabledBtn"
          text
          @click="confirm"
        >
          {{ 'Принять' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
  props: {
    type: String,
    loading: Boolean,
    messages: Array
  },

  data: () => ({
    text: ''
  }),

  validations() {
    return {
      text: { required },
    }
  },

  computed: {
    disabledBtn() {
      return !!(this.computedLabel && this.computedPlaceholder)
    },

    checkMsg() {
      return this.type === 'checkMsg'
    },

    computedTitleDialog() {
      switch (this.type) {
        case 'sendApp': return 'Отправить заявление'
        case 'removeApp': return 'Удалить заявление'

        case 'declineApp': return 'Не допустить заявление к конкурсу'
        case 'passApp': return 'Допустить заявление к конкурсу'
        case 'approveApp': return 'Принять заявление'
        case 'modificationApp': return 'Доработка заявления'
        case 'rejectApp': return 'Отклонить заявление'

        case 'sendNotice': return 'Отправить уведомление'
        case 'removeNotice': return 'Удалить уведомление'

        case 'removeRating': return 'Удалить рейтинг'
        case 'confirmRating': return  'Подтвердить ранжирование'

        case 'checkMsg': return 'Просмотр сообщения'
      }
    },

    computedMessageDialog() {
      switch (this.type) {
        case 'sendApp': return 'Вы уверены, что хотите отправить заявление?'
        case 'removeApp': return 'Вы уверенны, что ходите удалить заявление?'

        case 'passApp': return 'Вы уверены, что хотите допустить заявление к конкурсу?'
        case 'approveApp': return 'Вы уверены, что хотите принять заявление?'

        case 'sendNotice': return 'Вы уверены, что хотите отправить уведомление?'
        case 'removeNotice': return 'Вы уверенны, что ходите удалить уведомление?'

        case 'removeRating': return 'Вы уверены, что хотите удалить данный рейтинг?'
        case 'confirmRating': return 'Вы уверены, что хотите ранжировать данный рейтинг?'
      }
    },

    computedLabel() {
      switch (this.type) {
        case 'rejectApp': return 'Отклонить заявления'
        case 'modificationApp': return 'Доработка заявления'
        case 'declineApp': return 'Не допустить заявление к конкурсу'
      }
    },

    computedPlaceholder() {
      switch (this.type) {
        case 'rejectApp': return 'Введите причину отклонения заявления'
        case 'modificationApp': return 'Введите причину доработки заявления'
        case 'declineApp': return 'Введите причину недопуска заявление к конкурсу'
      }
    },
  },

  methods: {
    confirm() {
      this.$emit('confirm', this.text)
      this.resetModal()
    },

    closeDialog() {
      this.resetModal()
      this.$emit('closeDialog')
    },

    resetModal() {
      this.$v.$reset()
      this.text = ''
    },
  },
}
</script>

<style scoped>
.border-top {
  border: 0 !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}

.theme--light.v-btn.v-btn--disabled {
  color: #dadada !important
}
</style>
